global.conmed = global.conmed || {};

conmed.calculatorModal = function ($) {
    'use strict';

    var that = {
        selectors: {
            btn: '.calc-btn',
            rohiBtn: '#rohiCalculateBtn',
            modal: '#calculatorModal',
            modalCloseBtn: '#calculatorModal .btn-close',
            formAge: "#form-age",
            formApTearSize: "#form-ap-tear-size",
            formRetraction: "#form-retraction",
            formInfraspinatus: "#form-infraspinatus-fatty-infiltration-grade",
            formActivity: "#form-level-of-work-activity",
            formBone: "#form-bone-mineral-density",
            chanceHealing: "#ChanceHealing",
            rohiScore: "#RoHIScore",
            calculatorArrow: "#CalculatorArrow",
            greenScore: ".green-score",
            greenHealing: ".green-healing",
            yellowScore: ".yellow-score",
            yellowHealing: ".yellow-healing",
            redScore: ".red-score",
            redHealing: ".red-healing",
            darkRedScore: ".dark-red-score",
            darkRedHealing: ".dark-red-healing",
            customerForm: "#CustomerForm",
            emailMeResults: "#emailMeResults"
        }
    };

    that.init = function () {

        $(that.selectors.btn).on('click', function (e) {
            e.preventDefault();
            $(that.selectors.modal).delay(100).fadeIn(250);
            $("body").addClass("modal-open");

        });

        $(that.selectors.modalCloseBtn).on('click', function (e) {
            e.preventDefault();
            $(that.selectors.modal).hide();
            $("body").removeClass("modal-open")
        });

        $(that.selectors.rohiBtn).on('click', function (e) {
            e.preventDefault();

            $(that.selectors.greenScore).removeClass("selected");
            $(that.selectors.greenHealing).removeClass("selected");
            $(that.selectors.yellowScore).removeClass("selected");
            $(that.selectors.yellowHealing).removeClass("selected");
            $(that.selectors.redScore).removeClass("selected");
            $(that.selectors.redHealing).removeClass("selected");
            $(that.selectors.darkRedScore).removeClass("selected");
            $(that.selectors.darkRedHealing).removeClass("selected");
            $(that.selectors.calculatorArrow).css("visibility", "hidden");
            $(that.selectors.customerForm).css("display", "block");

            let sum = 0;

            $('.form-score').each(function () {
                sum += parseFloat($(this).attr("data-test-val"));
            });

            var result = "-";

            if (0 <= sum && sum <= 4) {
                result = "94%";
                $(that.selectors.greenScore).addClass("selected");
                $(that.selectors.greenHealing).addClass("selected");
                $(that.selectors.calculatorArrow).css("visibility", "visible");
                $(that.selectors.calculatorArrow).css("margin-left", ((sum / 16) * 100) + "%");
            } else if (5 <= sum && sum <= 6) {
                result = "68%";
                $(that.selectors.yellowScore).addClass("selected");
                $(that.selectors.yellowHealing).addClass("selected");
                $(that.selectors.calculatorArrow).css("visibility", "visible");
                $(that.selectors.calculatorArrow).css("margin-left", ((sum / 16) * 100) + "%");
            } else if (6 <= sum && sum <= 9) {
                result = "38%";
                $(that.selectors.redScore).addClass("selected");
                $(that.selectors.redHealing).addClass("selected");
                $(that.selectors.calculatorArrow).css("visibility", "visible");
                $(that.selectors.calculatorArrow).css("margin-left", ((sum / 16) * 100) + "%");
            } else if (10 <= sum) {
                result = "4%";
                $(that.selectors.darkRedScore).addClass("selected");
                $(that.selectors.darkRedHealing).addClass("selected");
                $(that.selectors.calculatorArrow).css("visibility", "visible");
                $(that.selectors.calculatorArrow).css("margin-left", ((sum / 16) * 100) + "%");
            }

            $(that.selectors.chanceHealing).text(result);
            $(that.selectors.rohiScore).text(sum);
        });

        $(that.selectors.formAge).on('change', function (e) {
            var calcVal = this.value;
            if (calcVal == -1) {
                calcVal = '-';
                $(this).siblings('.form-score').text(calcVal);
                $(this).siblings('.form-score').attr('data-test-val', 0);
            } else {
                $(this).siblings('.form-score').text(calcVal);
                $(this).siblings('.form-score').attr('data-test-val', calcVal);
            }

        })

        $(that.selectors.formApTearSize).on('change', function (e) {
            var calcVal = this.value;

            if (calcVal === "-1") {
                calcVal = '-';
                $(this).siblings('.form-score').text(calcVal);
                $(this).siblings('.form-score').attr('data-test-val', 0);
            } else {
                $(this).siblings('.form-score').text(calcVal);
                $(this).siblings('.form-score').attr('data-test-val', calcVal);
            }

        })

        $(that.selectors.formRetraction).on('change', function (e) {
            var calcVal = this.value;

            if (calcVal === "-1") {
                calcVal = '-';
                $(this).siblings('.form-score').text(calcVal);
                $(this).siblings('.form-score').attr('data-test-val', 0);
            } else {
                $(this).siblings('.form-score').text(calcVal);
                $(this).siblings('.form-score').attr('data-test-val', calcVal);
            }

        })

        $(that.selectors.formInfraspinatus).on('change', function (e) {
            var calcVal = this.value;

            if (calcVal === "-1") {
                calcVal = '-';
                $(this).siblings('.form-score').text(calcVal);
                $(this).siblings('.form-score').attr('data-test-val', 0);
            } else {
                $(this).siblings('.form-score').text(calcVal);
                $(this).siblings('.form-score').attr('data-test-val', calcVal);
            }

        })

        $(that.selectors.formActivity).on('change', function (e) {
            var calcVal = this.value;

            if (calcVal === "-1") {
                calcVal = '-';
                $(this).siblings('.form-score').text(calcVal);
                $(this).siblings('.form-score').attr('data-test-val', 0);
            } else {
                $(this).siblings('.form-score').text(calcVal);
                $(this).siblings('.form-score').attr('data-test-val', calcVal);
            }

        })

        $(that.selectors.formBone).on('change', function (e) {
            var calcVal = this.value;

            if (calcVal === "-1") {
                calcVal = '-';
                $(this).siblings('.form-score').text(calcVal);
                $(this).siblings('.form-score').attr('data-test-val', 0);
            } else {
                $(this).siblings('.form-score').text(calcVal);
                $(this).siblings('.form-score').attr('data-test-val', calcVal);
            }

        })

        $(that.selectors.emailMeResults).on('click', function (e) {
            e.preventDefault();

            var ageDropdown = document.getElementById("form-age");
            var ageDropDownIndex = ageDropdown.selectedIndex;
            var ageDropDownIndexText = ageDropdown.options[ageDropDownIndex].text;
            document.getElementById("field182761044").value = ageDropDownIndexText
            document.getElementById("field182761044").setAttribute("value", ageDropDownIndexText);
            document.getElementById("field182761044").dispatchEvent(new Event("input"));

            var apTearSize = document.getElementById("form-ap-tear-size");
            var apTearSizeIndex = apTearSize.selectedIndex;
            var apTearSizeIndexText = apTearSize.options[apTearSizeIndex].text;
            document.getElementById("field182761077").value = apTearSizeIndexText
            document.getElementById("field182761077").setAttribute("value", apTearSizeIndexText);
            document.getElementById("field182761077").dispatchEvent(new Event("input"));

            var retraction = document.getElementById("form-retraction");
            var retractionIndex = retraction.selectedIndex;
            var retractionIndexText = retraction.options[retractionIndex].text;
            document.getElementById("field182761076").value = retractionIndexText
            document.getElementById("field182761076").setAttribute("value", retractionIndexText);
            document.getElementById("field182761076").dispatchEvent(new Event("input"));

            var infiltrationGrade = document.getElementById("form-infraspinatus-fatty-infiltration-grade");
            var infiltrationGradeIndex = infiltrationGrade.selectedIndex;
            var infiltrationGradeIndexText = infiltrationGrade.options[infiltrationGradeIndex].text;
            document.getElementById("field182761075").value = infiltrationGradeIndexText
            document.getElementById("field182761075").setAttribute("value", infiltrationGradeIndexText);
            document.getElementById("field182761075").dispatchEvent(new Event("input"));

            var levelOfWork = document.getElementById("form-level-of-work-activity");
            var levelOfWorkIndex = levelOfWork.selectedIndex;
            var levelOfWorkIndexText = levelOfWork.options[levelOfWorkIndex].text;
            document.getElementById("field182761074").value = levelOfWorkIndexText
            document.getElementById("field182761074").setAttribute("value", levelOfWorkIndexText);
            document.getElementById("field182761074").dispatchEvent(new Event("input"));

            var boneMineralDensity = document.getElementById("form-bone-mineral-density");
            var boneMineralDensityIndex = boneMineralDensity.selectedIndex;
            var boneMineralDensityIndexText = boneMineralDensity.options[boneMineralDensityIndex].text;
            document.getElementById("field182761045").value = boneMineralDensityIndexText
            document.getElementById("field182761045").setAttribute("value", boneMineralDensityIndexText);
            document.getElementById("field182761045").dispatchEvent(new Event("input"));

            var returnUrlField = document.getElementById("field182971780");
            var returnUrl = window.location.href.split('?')[0] + "?Q1=" + document.getElementById("form-age").selectedIndex + "&Q2=" + document.getElementById("form-ap-tear-size").selectedIndex + "&Q3=" + document.getElementById("form-retraction").selectedIndex + "&Q4=" + document.getElementById("form-infraspinatus-fatty-infiltration-grade").selectedIndex + "&Q5=" + document.getElementById("form-level-of-work-activity").selectedIndex + "&Q6=" + document.getElementById("form-bone-mineral-density").selectedIndex;
            returnUrlField.value = returnUrl;
            returnUrlField.setAttribute("value", returnUrl);

            var chanceHealingField = document.getElementById("field183221396");
            chanceHealingField.value = $(that.selectors.chanceHealing).text();

            var RohiScoreField = document.getElementById("field183221397");
            RohiScoreField.value = $(that.selectors.rohiScore).text();

            var form = document.getElementById("fsForm6167991");
            form.submit();
        });
    };

    return that;
}(jQuery);